import { ListingFilters } from "@/lib/fetch/listing";
import {
  Building,
  Car,
  Check,
  DoorOpen,
  Home,
  Hotel,
  LampDesk,
} from "lucide-react";
import { useTranslations } from "next-intl";
import { twMerge } from "tailwind-merge";
import FilterWrapper from "./FilterWrapper";
import React from "react";

type Props = {
  value: ListingFilters["type"];
  setValue: (value: ListingFilters["type"]) => void;
};

const FilterPropertyType: React.FC<Props> = ({ setValue, value }) => {
  const t = useTranslations("listing");
  const tS = useTranslations("search");

  const options = [
    {
      name: "APARTMENT",
      icon: <Building className="size-4" />,
    },
    {
      name: "HOUSE",
      icon: <Home className="size-4" />,
    },
    {
      name: "ROOM",
      icon: <DoorOpen className="size-4" />,
    },
    {
      name: "STUDIO",
      icon: <LampDesk className="size-4" />,
    },
    {
      name: "PARKING",
      icon: <Car className="size-4" />,
    },
  ] as const;

  return (
    <FilterWrapper
      title={t("attribute_title.PROPERTY_TYPE")}
      icon={<Hotel />}
      clear={() => setValue(undefined)}
      showClear={!!value?.length}
      summary={!value?.length ? tS("any-type") : undefined}
    >
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const selected = !!value?.includes(option.name);
          return (
            <button
              key={option.name}
              type="button"
              aria-pressed={selected}
              onClick={() => {
                if (!value) {
                  setValue([option.name]);
                } else if (selected) {
                  const newValue = value.filter((v) => v !== option.name);
                  setValue(newValue.length > 0 ? newValue : undefined);
                } else {
                  setValue([...value, option.name]);
                }
              }}
              className={twMerge(
                "flex min-h-10 items-center gap-2 rounded-xl border border-input bg-background px-3 text-sm font-medium text-foreground transition-colors hover:border-zinc-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1",
                selected &&
                  "border-primary bg-secondary font-semibold text-secondary-foreground hover:border-primary",
              )}
            >
              {selected ? (
                <Check className="size-4" strokeWidth={2.5} />
              ) : (
                <span className="text-muted-foreground">{option.icon}</span>
              )}
              {t(`attributes.PROPERTY_TYPE.${option.name}`)}
            </button>
          );
        })}
      </div>
    </FilterWrapper>
  );
};

export default FilterPropertyType;
